class ModalForm {
  modal = undefined;
  constructor(modal, analyticsTracking) {
    this.modal = modal;
    this.analyticsTracking = analyticsTracking;
    this.form = modal.querySelectorAll("form")[0];
    this.form.setAttribute("data-content-name", "contact-us-form");
    this.form_id = this.form.getAttribute("data-form-id");
    this.submitButton = this.form.querySelectorAll('[type="submit"]')[0];
    this.registerEvents();
  }

  registerEvents() {
    if (this.modal) {
      this.analyticsTracking.notifyMotomo("trackForm", this.form);

      this.form.addEventListener(
        "submit",
        function (event) {
          if (this.submitButton) {
            this.submitButton.disabled = true;
          }
        }.bind(this)
      );

      window.wplf.successCallbacks.push(this.formSubmitted.bind(this));
      window.wplf.errorCallbacks.push(this.formSubmittedError.bind(this));
    }
  }

  formSubmitted(res) {
    if (res.form_id != this.form_id) return;

    this.analyticsTracking.notifyMotomo("trackFormConversion", this.form);
  }

  formSubmittedError(res) {
    if (res.form_id != this.form_id) return;

    if (this.submitButton) {
      this.submitButton.disabled = false;
    }
  }
}
export default ModalForm;
